import Http from '../../../lib/http'
import { ADMIN_LIFECYCLE_ACTIONS } from './lifecycle.constants'
import { parseLifecycleResponse } from './lifecycle.utils'

export async function requestAccountReactivation(email) {
  const result = await Http.post('/api/auth/account-reactivation/request', { email })
  return parseLifecycleResponse(result)
}

export async function confirmAccountReactivation(token) {
  const result = await Http.post('/api/auth/account-reactivation/confirm', { token })
  return parseLifecycleResponse(result)
}

export async function requestLifecycleDeletion(payload) {
  const result = await Http.post('/api/account/lifecycle/deletion-request', payload)
  return parseLifecycleResponse(result)
}

export async function cancelDeletionRequest(token) {
  const result = await Http.post('/api/account/deletion-request/cancel', { token })
  return parseLifecycleResponse(result)
}

export async function deactivateOwnAccount(payload) {
  const result = await Http.post('/api/account/lifecycle/deactivate', payload)
  return parseLifecycleResponse(result)
}

export async function postAdminCompanyLifecycle(companyId, action, payload = {}) {
  const result = await Http.post(`/api/admin/companies/${companyId}/${action}`, payload)
  return parseLifecycleResponse(result)
}

export async function fetchAdminCompany(companyId) {
  const fallback = await Http.get(`/api/companies/${companyId}`)
  return parseLifecycleResponse(fallback)
}

export const adminLifecycleActionPath = {
  [ADMIN_LIFECYCLE_ACTIONS.DEACTIVATE]: ADMIN_LIFECYCLE_ACTIONS.DEACTIVATE,
  [ADMIN_LIFECYCLE_ACTIONS.REACTIVATE]: ADMIN_LIFECYCLE_ACTIONS.REACTIVATE,
  [ADMIN_LIFECYCLE_ACTIONS.SUSPEND]: ADMIN_LIFECYCLE_ACTIONS.SUSPEND,
  [ADMIN_LIFECYCLE_ACTIONS.UNSUSPEND]: ADMIN_LIFECYCLE_ACTIONS.UNSUSPEND,
}
